import React from 'react';
import { connect } from 'react-redux';

import { Button, createComponent, enums, Header, Label, Layout, CKForm } from 'console-kit';

import authStatics from '../../../common/static';

import LostPasswordPanelSelectors from '../redux/selectors';
import LostPasswordPanelActions from '../redux/actions';

import AuthImageLogo from '../../../components/AuthImageLogo';
import ValidatableEmailInput from '../../../components/AuthEmailValidatableWrapper';

import { FORM_ID } from '../index';

const LostPasswordPanel = createComponent({
  displayName: 'LostPasswordPanel',
  refs:        'lostPasswordFormRef',
  handlers:    {
    handleValueChange:
      (p) =>
        (e, { id, value }) => {
          p.onUpdateField({ fieldId: id, value });
        },

    handleClick:
      (p) =>
        (e, { value }) => {
          e.preventDefault();
          p.onLostPasswordClicked(p.refs.lostPasswordFormRef);
        },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <CKForm.Form formId={FORM_ID}>
          <form ref={props.setLostPasswordFormRef} action={authStatics.LOSTPASSWORD_FORM_SUBMIT_URL}>
            <Layout>
              <Layout.Row>
                <Layout.Column textAlign={enums.textAlignments.CENTER}>
                  <AuthImageLogo />
                </Layout.Column>
              </Layout.Row>

              <Layout.Row>
                <Layout.Column textAlign={enums.textAlignments.LEFT}>
                  <Header
                    text="Reset Password"
                    isDividing={false}
                    font={{
                      emphasis: enums.font.emphasis.NORMAL,
                    }}
                    size={enums.sizes.X6}
                  />
                </Layout.Column>
              </Layout.Row>

              <Layout.Row>
                <Layout.Column textAlign={enums.textAlignments.LEFT}>
                  <Label
                    text="It seems you are having a hard time logging in. Just fill out the email address associated with your Grow by Zeta account. You will then receive a link to reset your password."
                    hasPadding={false}
                    display={enums.display.PLAIN}
                    size={enums.sizes.X4}
                    isFluid
                  />
                </Layout.Column>
              </Layout.Row>

              <Layout.Row>
                <Layout.Column>
                  <ValidatableEmailInput
                    formId={FORM_ID}
                    fieldId="lostPasswordEmail"
                    validateOn="onBlur"
                    label="Email"
                    isFluid={true}
                    placeholder="name@email.com"
                    type="email"
                    id="email"
                    name="email"
                    isUnderlined={false}
                    onChange={props.handleValueChange}
                    value={props.email}
                  />
                </Layout.Column>
              </Layout.Row>

              <Layout.Row>
                <Button.WithAnimation
                  actions={{
                    start:   LostPasswordPanelActions.onLostPasswordPanelRequest,
                    success: LostPasswordPanelActions.onLostPasswordPanelSuccess, //no action
                    failure: LostPasswordPanelActions.onLostPasswordPanelFailure, //no action
                  }}
                >
                  <Button.Primary
                    text="Reset"
                    float={enums.positions.RIGHT}
                    size={enums.sizes.X4}
                    onClick={props.handleClick}
                    textAlign={enums.textAlignments.CENTER}
                    color={enums.colors.ACCENT}
                    isSolid
                    isFluid
                    isDisabled={false}
                  />
                </Button.WithAnimation>
              </Layout.Row>
            </Layout>
          </form>
        </CKForm.Form>
      </div>
    );
  },
});

export default connect(
  (state) => {
    return {
      email: LostPasswordPanelSelectors.email(state),
    };
  },
  (dispatch) => ({
    onUpdateField({ fieldId, value }) {
      dispatch(LostPasswordPanelActions.updateField(fieldId, value));
    },

    onLostPasswordClicked(formRef) {
      dispatch(LostPasswordPanelActions.onLostPasswordPanelRequest(formRef));
    },
  })
)(LostPasswordPanel);
